import { HttpErrorResponse } from '@angular/common/http';

/** Shown when the API refuses a module the school's plan doesn't include. */
export const MODULE_NOT_IN_PLAN_MESSAGE = "This module isn't part of your school's plan.";

/** True for the API's plan-gate refusal (403 MODULE_NOT_IN_PLAN). */
export function isModuleNotInPlan(err: unknown): boolean {
  if (!(err instanceof HttpErrorResponse) || err.status !== 403) return false;
  const body = err.error as { error?: { code?: string } } | null;
  return !!body && typeof body === 'object' && body.error?.code === 'MODULE_NOT_IN_PLAN';
}

/** Extract a user-facing message from any thrown value (API envelope aware). */
export function getApiErrorMessage(err: unknown): string {
  if (isModuleNotInPlan(err)) {
    return MODULE_NOT_IN_PLAN_MESSAGE;
  }
  if (err instanceof HttpErrorResponse) {
    const body = err.error as
      | { error?: { message?: string } }
      | string
      | null;
    if (body && typeof body === 'object' && body.error?.message) {
      return body.error.message;
    }
    if (typeof body === 'string' && body.trim()) {
      return body;
    }
    if (err.status === 0) {
      return 'Cannot reach the server. Is the API running?';
    }
    return err.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return 'Something went wrong';
}
